const TRAILS = [
  {
    name: 'Whiteside Mountain Trail',
    difficulty: 'Moderate',
    duration: '2–3 hours',
    description:
      'A 2-mile loop past some of the oldest exposed rock faces in North America, rising 2,100 feet above the valley. The trail offers sweeping views across the Nantahala National Forest and is consistently ranked among the top hikes in the southern Appalachians.',
    image: 'https://public.readdy.ai/ai/img_res/8ea46338cdccaba55630dd453bc0042f.jpg',
  },
  {
    name: 'Satulah Mountain Trail',
    difficulty: 'Moderate',
    duration: '1–2 hours',
    description:
      'A rewarding hike to the summit of Satulah Mountain, one of the high peaks surrounding Highlands. The trail winds through quiet forest and opens to a panoramic view at the top, making it a favorite for a shorter but satisfying outing.',
    image: 'https://readdy.ai/api/search-image?query=forest%20hiking%20trail%20to%20mountain%20summit%20near%20Highlands%20North%20Carolina%20dappled%20sunlight%20through%20canopy%20of%20hardwood%20trees%20lush%20green%20undergrowth%20ferns%20peaceful%20quiet%20mountain%20path%20travel%20nature%20photography%20warm%20afternoon%20light&width=800&height=580&seq=hiking-trail-highlands-nc-satulah-02&orientation=landscape',
  },
  {
    name: 'Glen Falls Trail',
    difficulty: 'Moderate',
    duration: '2–3 hours',
    description:
      'The Glen Falls Trail descends through forested terrain to a series of cascading waterfalls along the East Fork of Overflow Creek. The trail offers multiple viewpoints at different levels of the falls, making it one of the more varied and scenic hikes in the area.',
    image: 'https://readdy.ai/api/search-image?query=glen%20falls%20trail%20forest%20path%20descending%20alongside%20cascading%20waterfall%20Highlands%20North%20Carolina%20hikers%20on%20rocky%20trail%20lush%20green%20ferns%20and%20mossy%20rocks%20surrounded%20by%20tall%20trees%20mountain%20creek%20travel%20photography%20serene%20nature&width=800&height=580&seq=glen-falls-highlands-nc-trail-03&orientation=landscape',
  },
];

export default function HikingSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14" id="hiking">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Outdoor Adventure</p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light">
            Hiking <em className="italic">Trails</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TRAILS.map((trail) => (
            <article key={trail.name} className="bg-white rounded-2xl overflow-hidden group">
              <div className="h-52 overflow-hidden">
                <img
                  src={trail.image}
                  alt={`${trail.name} — hiking trail in Highlands NC mountains`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[#6B8C7D] text-xs tracking-widest uppercase font-jost">Hiking</span>
                  <span className="text-[#E5E0D8] text-xs">•</span>
                  <span className="text-[#9C9890] text-xs font-jost">{trail.difficulty}</span>
                  <span className="text-[#E5E0D8] text-xs">•</span>
                  <span className="text-[#9C9890] text-xs font-jost">{trail.duration}</span>
                </div>
                <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-3 leading-tight">{trail.name}</h3>
                <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{trail.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 max-w-2xl mx-auto text-center">
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
            Hiking is one of the most popular things to do in Highlands, NC, with trails ranging from easy walks to more challenging mountain hikes.
          </p>
        </div>
      </div>
    </section>
  );
}
